module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__body px-4 pt-4 pb-5"
  }, [_c('label', {
    staticClass: "mb-3 pay-in__review-label"
  }, [_vm._v("Review your payments")]), _vm._v(" "), _vm._l((_vm.payments), function(payment, index) {
    return _c('pay-in-summary-card', {
      key: index,
      attrs: {
        "payment": payment,
        "index": index,
        "isPartial": _vm.isPartial,
        "amount": payment.paidValue,
        "willCreateInvoiceForAllPayments": _vm.willCreateInvoiceForAllPayments,
        "isFromCreatePayin": _vm.isFromCreatePayin
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-in__summary-totals mb-3"
  }, [_c('div', {
    staticClass: "pay-in__summary-row pay-in__summary-row--total px-3"
  }, [_c('span', {
    staticClass: "font-weight-600 fs-small darkest"
  }, [_vm._v("Total paid")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-600 fs-large pay-in__green"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalPaid)) + "€")])]), _vm._v(" "), (_vm.finalChange > 0) ? _c('div', {
    staticClass: "pay-in__summary-row px-3 py-1"
  }, [_c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v("Change")]), _vm._v(" "), _c('span', {
    staticClass: "darkest fs-large font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.finalChange)) + "€")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pay-in__summary-row px-3 py-1"
  }, [_c('span', {
    staticClass: "darkest fs-small"
  }, [_vm._v("Remaining balance")]), _vm._v(" "), _c('span', {
    staticClass: "darkest fs-large font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.remainingBalance)) + "€")])])]), _vm._v(" "), (_vm.shouldShowInvoiceDropdown) ? [_c('div', {
    staticClass: "pay-in__invoice-dropdown mt-4"
  }, [_c('label', {
    staticClass: "pay-in__invoice-dropdown-label mb-2 d-block"
  }, [_vm._v("Review your invoice options")]), _vm._v(" "), _c('v-select', {
    staticClass: "pay-in__invoice-select",
    attrs: {
      "label": "name",
      "options": _vm.invoiceModeOptions
    },
    on: {
      "input": _vm.onInvoiceModeChanged
    },
    model: {
      value: (_vm.localInvoiceMode),
      callback: function($$v) {
        _vm.localInvoiceMode = $$v
      },
      expression: "localInvoiceMode"
    }
  })], 1)] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0d4bedf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4bedf4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/Step3Summary.vue
// module id = 2010
// module chunks = 0